import React from 'react';
import { Info, User } from 'lucide-react';



const EVENT_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Active — visible & selling' },
  { value: 'VIEW_ONLY', label: 'Visible — sales paused' },
  { value: 'HIDDEN', label: 'Hidden — not visible' }
];

const BasicInfoStep = ({
  formData,
  errors,
  eventCategories,
  eventTypes,
  handleInputChange,
  isAdmin = false
}) => {


  return (
    <div className="form-section">
      <h3>
        <Info size={24} />
        Basic Event Information
      </h3>
      <p>Let's start with the essential details about your amazing event!</p>



      <div className="form-field required">
        <label>
          <span>Event Title</span>
        </label>
        <input
          type="text"
          value={formData.title}
          onChange={(e) => handleInputChange('title', e.target.value)}
          className={`wizard-input ${errors.title ? 'error' : ''}`}
          placeholder="e.g., Persian Night: Classical & Contemporary Music Concert"
          maxLength={255}
        />
        <div className={`character-counter ${formData.title.length > 200 ? 'warning' : ''}`}>
          {formData.title.length}/255 characters
        </div>
        {errors.title && <div className="error-message">{errors.title}</div>}
      </div>

      {isAdmin && (
        <div className="form-field required">
          <label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <User size={14} /> Planner Email
            </div>
          </label>
          <input
            type="email"
            value={formData.plannerEmail || ''}
            onChange={(e) => handleInputChange('plannerEmail', e.target.value)}
            className={`wizard-input ${errors.plannerEmail ? 'error' : ''}`}
            placeholder="planner@example.com"
          />
          {errors.plannerEmail && <div className="error-message">{errors.plannerEmail}</div>}
        </div>
      )}

      <div className="form-field required">
        <label>Event Description</label>
        <textarea
          value={formData.description}
          onChange={(e) => handleInputChange('description', e.target.value)}
          className={`wizard-textarea ${errors.description ? 'error' : ''}`}
          placeholder="Paint a vivid picture of your event... What can attendees expect?"
          maxLength={5000}
        />
        <div className={`character-counter ${formData.description.length > 4500 ? 'warning' : ''}`}>
          {formData.description.length}/5000 characters
        </div>
        {errors.description && <div className="error-message">{errors.description}</div>}
      </div>





      <div className="form-grid">
        <div className="form-field required">
          <label>Event Category</label>
          <select
            value={formData.category}
            onChange={(e) => handleInputChange('category', e.target.value)}
            className={`wizard-select ${errors.category ? 'error' : ''}`}
          >
            <option value="">Select Category</option>
            {eventCategories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
          {errors.category && <div className="error-message">{errors.category}</div>}
        </div>

        <div className="form-field required">
          <label>Event Type</label>
          <select
            value={formData.eventType}
            onChange={(e) => handleInputChange('eventType', e.target.value)}
            className={`wizard-select ${errors.eventType ? 'error' : ''}`}
          >
            <option value="">Select Type</option>
            {eventTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          {errors.eventType && <div className="error-message">{errors.eventType}</div>}
        </div>

        <div className="form-field required">
          <label>Event Status</label>
          <select
            value={formData.status || ''}
            onChange={(e) => handleInputChange('status', e.target.value)}
            className={`wizard-select ${errors.status ? 'error' : ''}`}
          >
            <option value="">Select status</option>
            {EVENT_STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {errors.status && <div className="error-message">{errors.status}</div>}
        </div>
      </div>
    </div >
  );
};

export default BasicInfoStep;
